// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import caseBusi from './metaData/caseBusi'
export default {
  state: caseBusi,
  actions
}
